import { useEffect } from "react";
import { useCallbackRef } from "../useCallbackRef.js";
function useEventListener(type, handler, element = document) {
    const savedCallbackRef = useCallbackRef(handler);
    useEffect(()=>{
        function eventListener(event) {
            return savedCallbackRef.current(event);
        }
        if (null != element) element.addEventListener(type, eventListener);
        return ()=>{
            if (null != element) element.removeEventListener(type, eventListener);
        };
    }, [
        type,
        element
    ]);
}
export { useEventListener };
